import React from 'react'
import Button from 'src/shared/components/Button'
import failedIcon from 'src/assets/img/wrong.png'
import { FormHelperText, Typography } from '@material-ui/core'
import { sendEventType } from '../..'
import useStyles from './useStyles'

interface Props {
  send: sendEventType
}

const onConfirm = (send: sendEventType) => {
  send({ type: 'SEND_EMAIL' })
}

const ResetFailed: React.FC<Props> = ({ send }) => {
  const classes = useStyles()

  return (
    <>
      <img className={classes.failedIcon} src={failedIcon} alt='' />
      <Typography variant='h5' className={classes.mainTitle}>
        鏈結已失效
      </Typography>
      <FormHelperText className={classes.heplerText}>鏈結已超過有效時間 (10分鐘)，請重新輸入電子郵件地址，收取重置密碼信。</FormHelperText>
      <Button onClick={() => onConfirm(send)} type='submit'>
        寄給我重置密碼信
      </Button>
    </>
  )
}

export default ResetFailed
